import { Fragment, useEffect, useLayoutEffect, useRef, useState } from "react";
import { getAllTransactionsData } from "../../services/rashTradeServices";
import { exportToExcel } from "../../utils/common-functions";
import Pagination from "../../utils/Pagination";
import { errorToastify } from "../../utils/Toastify";
import Modal from "../common-components/Modal";
import SelectInput from "../common-components/SelectInput";
import Table from "../common-components/table/Table";

const TransactionsDetails = ({
    headersList,
    sortOptions,
    receiveDataFunction,
    transactionsData,
    transactionType,
    rowsLength,
    currentCurrencyId,
    transSpinnerStatus,
    ComponentName,
    isDarkMode
}) => {
    const tableButtonBarRef = useRef();
    const [state, setState] = useState({
        showModal: false,
        sliceStart: 0,
        sliceEnd: 5,
        selectedSort: ""
    });
    const [page, setPage] = useState(0);
    const rowsPerPage = 20;
    const paginationRange = new Array(
        Math.ceil((rowsLength < rowsPerPage ? rowsPerPage : rowsLength) / rowsPerPage)
    )
        .fill()
        .map((x, i) => i);
    useEffect(() => {
        if (state.showModal) {
            receiveDataFunction(page, state.selectedSort);
        }
        if (!state.showModal) {
            setPage(0);
        }
    }, [page, state.selectedSort, currentCurrencyId, state.showModal]);
    const didMountRef = useRef(false);
    useLayoutEffect(() => {
        const { sliceEnd, sliceStart } = state;
        if (didMountRef.current) {
            setState((prev) => {
                if (page + 1 === sliceEnd && page + 5 <= paginationRange.length) {
                    return {
                        ...prev,
                        sliceStart: prev.sliceStart + 4,
                        sliceEnd: prev.sliceEnd + 4
                    };
                }
                if (page + 1 === sliceEnd && page + 5 >= paginationRange.length) {
                    return {
                        ...prev,
                        sliceStart: paginationRange.length - 5,
                        sliceEnd: paginationRange.length
                    };
                }
                if (page === sliceStart && page - 5 <= 0) {
                    return {
                        ...prev,
                        sliceStart: 0,
                        sliceEnd: 5
                    };
                }
                if (page === sliceStart && page - 5 > 0) {
                    return {
                        ...prev,
                        sliceStart: prev.sliceStart - 4,
                        sliceEnd: prev.sliceEnd - 4
                    };
                }
                return prev;
            });
        }
        didMountRef.current = true;
    }, [page]);

    const exportDataToExcelFile = async () => {
        try {
            const { data } = await getAllTransactionsData({ transactionType });
            exportToExcel({
                apiData: data,
                fileName: `transactions-${currentCurrencyId}-${transactionType}`
            });
        } catch (error) {
            errorToastify("Failed to export to Excel file!");
        }
    };
    return (
        <Fragment>
            <div className="w-full min-h-7 flex text-vsm  px-3 ">
                <div
                    className={` flex justify-center cursor-pointer underline p-2 my-1 w-full rounded-lg ${
                        isDarkMode ? "bg-secondaryDark" : "bg-secondaryLight"
                    }`}>
                    <div
                        onClick={() =>
                            setState((prev) => ({
                                ...prev,
                                showModal: !prev.showModal
                            }))
                        }
                        className="flex-1 flex justify-start whitespace-nowrap">
                        {ComponentName}
                    </div>
                    <div className="flex-1 flex justify-end items-center">
                        <img
                            onClick={() => exportDataToExcelFile()}
                            className="max-w-3 "
                            src="/icons/exportToExcel.png"
                        />
                    </div>
                </div>
                {state.showModal ? (
                    <Modal modalClassName="charts_modal " toggleValue={state.showModal}>
                        <div className="    overflow-auto primaryScroll text-vsm 2xl:text-xs   h-full lg:w-11/12  border-1">
                            <Table
                                tableHeads={headersList}
                                data={transactionsData}
                                elements={{
                                    parentDiv: {
                                        className: `${
                                            headersList.length > 8 ? " min-w-max " : "w-full"
                                        }`,
                                        style: {}
                                    },
                                    thead: {
                                        className: ` ${
                                            isDarkMode ? "bg-primaryDark" : "bg-secondaryGreen"
                                        } w-full  text-white text-vsm 2xl:text-xs`,
                                        style: {}
                                    },
                                    th: {
                                        className: " h-11 w-20 text-center items-center",
                                        style: {}
                                    },
                                    tbody: {
                                        className: ` ${
                                            isDarkMode ? "bg-secondaryDark" : "bg-secondaryLight"
                                        }`,
                                        style: {}
                                    },
                                    tr: {
                                        className: ` ${
                                            isDarkMode
                                                ? "odd:bg-tertiaryDark odd:text-[#000]"
                                                : "odd:bg-tertiaryLight odd:text-black"
                                        } flex text-vsm 2xl:text-9xl`,
                                        style: {}
                                    },
                                    td: {
                                        className: `min-h-11 flex-1 ${
                                            headersList.length > 8 ? "min-w-17" : ""
                                        }    primaryScroll   items-center text-vsm 2xl:text-xs`
                                    }
                                }}
                            />
                            <div
                                ref={tableButtonBarRef}
                                style={{
                                    minWidth: headersList.length * 96
                                }}
                                className={` flex  items-center w-full   ${
                                    isDarkMode ? "bg-primaryDark" : "bg-primaryLight"
                                }`}>
                                <div
                                    style={{
                                        flex: 1,
                                        display: "flex",
                                        justifyContent: "center"
                                    }}>
                                    <img
                                        src={
                                            !transSpinnerStatus
                                                ? "/icons/checked-grey.png"
                                                : "/icons/loading.png"
                                        }
                                        alt="spinner"
                                        style={{ width: 30 }}
                                        onClick={() =>
                                            !transSpinnerStatus &&
                                            receiveDataFunction(page, state.selectedSort)
                                        }
                                        className={`cursor-pointer  ${
                                            !transSpinnerStatus ? "" : "transactions_loading"
                                        } ${isDarkMode ? "border-1 rounded-full" : "border-0"}`}
                                    />
                                </div>
                                <Pagination
                                    page={page}
                                    range={paginationRange.slice(state.sliceStart, state.sliceEnd)}
                                    setPage={setPage}
                                    props={{
                                        parentDiv: {
                                            className: "pagination",
                                            style: {
                                                visibility:
                                                    transactionsData?.length > 0
                                                        ? "visible"
                                                        : "hidden"
                                            }
                                        },
                                        btn: {
                                            className: "button",
                                            style: {}
                                        },
                                        prev: {
                                            className: "",
                                            style: {
                                                cursor: "pointer",
                                                fontSize: 25
                                            },
                                            content: (
                                                <div
                                                    className={`${
                                                        isDarkMode ? "text-[#fff]" : "text-[#000]"
                                                    }`}>
                                                    &laquo;
                                                </div>
                                            )
                                        },
                                        next: {
                                            className: "",
                                            style: {
                                                cursor: "pointer",
                                                fontSize: 25
                                            },

                                            content: (
                                                <div
                                                    className={`${
                                                        isDarkMode ? "text-[#fff]" : "text-[#000]"
                                                    }`}>
                                                    &raquo;
                                                </div>
                                            )
                                        }
                                    }}
                                    prevPageFunc={() =>
                                        setPage((prev) => {
                                            if (prev != 0 && !transSpinnerStatus) {
                                                return prev - 1;
                                            } else {
                                                return prev;
                                            }
                                        })
                                    }
                                    nextPageFunc={() =>
                                        setPage((prev) => {
                                            if (
                                                prev + 1 != Math.ceil(rowsLength / rowsPerPage) &&
                                                Math.ceil(rowsLength / rowsPerPage) != 0 &&
                                                !transSpinnerStatus
                                            ) {
                                                return prev + 1;
                                            } else {
                                                return prev;
                                            }
                                        })
                                    }
                                />
                                <div
                                    style={{
                                        flex: 1,
                                        minHeight: 50,
                                        display: "flex",
                                        alignItems: "center"
                                    }}>
                                    <SelectInput
                                        selectFunction={(value) =>
                                            setState((prev) => {
                                                return {
                                                    ...prev,
                                                    selectedSort: value.option
                                                };
                                            })
                                        }
                                        selectHolder={{
                                            styles: {},
                                            className: "min-w-9 flex min-h-7  py-3 z-50 rounded-lg"
                                        }}
                                        selectOptions={{
                                            holderStyle: {},
                                            className: "flex justify-center relative z-50",
                                            selectedValue: {
                                                defaultText: state?.selectedSort
                                                    ? state?.selectedSort
                                                    : "SORT BY",
                                                style: {},
                                                className: `${
                                                    isDarkMode
                                                        ? "bg-primaryDark border-1"
                                                        : "bg-secondaryLight "
                                                } min-w-17 min-h-7   flex justify-center items-center cursor-pointer text-vsm md:min-h-9 md:min-w-21`
                                            },
                                            list: {
                                                holderStyle: {},
                                                className: "absolute bottom-12",
                                                options: Object.values(sortOptions),
                                                singleOption: {
                                                    divStyle: {
                                                        zIndex: 100
                                                    },
                                                    divClassName: ` ${
                                                        isDarkMode
                                                            ? "bg-primaryDark border-1"
                                                            : "bg-tertiaryLight "
                                                    } z-50 min-w-17 min-h-7 mt-2 primaryBoxShadow flex items-center justify-center cursor-pointer md:min-h-9 md:min-w-21`,
                                                    labelStyle: {
                                                        cursor: "pointer",
                                                        fontSize: 10
                                                    },
                                                    labelClassName: "",
                                                    inputStyle: {
                                                        display: "none"
                                                    }
                                                }
                                            }
                                        }}
                                        optionName="option"
                                        isEditable={true}
                                    />
                                </div>
                            </div>
                        </div>
                        <div
                            style={{
                                position: "absolute",
                                top: "2%",
                                right: "2%",
                                fontSize: 30,
                                color: "#fff"
                            }}
                            className="cursor-pointer"
                            onClick={() =>
                                setState((prev) => ({
                                    ...prev,
                                    showModal: !prev.showModal
                                }))
                            }>
                            X
                        </div>
                    </Modal>
                ) : null}
            </div>
        </Fragment>
    );
};

export default TransactionsDetails;
